var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h3',{staticClass:"text-center"},[_vm._v(" Accessoires ")]),_c('div',[_c('apexchart',{attrs:{"type":"line","options":_vm.options,"series":_vm.series}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }